import { render, staticRenderFns } from "./CustomerRow.vue?vue&type=template&id=5b3f6438&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./CustomerRow.vue?vue&type=script&lang=ts"
export * from "./CustomerRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f6438",
  null
  
)

export default component.exports